import { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { ILeadFormModel } from '../../../typings'
import {
  CampaignFieldId,
  entityCampaignId,
  entityLeadSourceId,
  leadSourceNone,
  leadSourceNoneId,
  SourceFieldId,
} from '@user/components/Settings/EntityFormSettings'
import { ISource } from '@user/store/sources/typings'
import { ICampaign } from '@user/store/campaigns/typings'
import { UseData } from './useData'

type Props = Pick<
  UseData,
  | 'setCampaignDisabled'
  | 'showCampaign'
  | 'requiredCampaignId'
  | 'showLeadSource'
  | 'requiredLeadSourceId'
> & {
  leadSources?: ISource[]
  campaigns?: ICampaign[]
}

export function useEffects(props: Props) {
  const {
    leadSources = [],
    campaigns = [],
    setCampaignDisabled,
    requiredCampaignId,
    requiredLeadSourceId,
    showCampaign,
    showLeadSource,
  } = props

  const {
    setFieldValue,
    setValues,
    values: { callTrackingActivity, campaignId, leadSourceId },
  } = useFormikContext<ILeadFormModel>()

  useEffect(() => {
    if (callTrackingActivity?.callActivityDetails) {
      setCampaignDisabled(true)
      setValues((current) => ({
        ...current,
        leadSourceId: '',
        leadSource: '',
        campaignId: '',
        campaign: '',
      }))

      const callSourceName = callTrackingActivity?.callActivityDetails
        .find((x) => x.callTrackingSystemFieldId === SourceFieldId)
        ?.fieldValue?.toUpperCase()

      if (callSourceName) {
        const foundLeadSource = leadSources.find(
          (x) => x.name.substring(0, 10) === callSourceName,
        )

        if (foundLeadSource) {
          setFieldValue(entityLeadSourceId, foundLeadSource.id)
          setFieldValue('leadSource', foundLeadSource.name)

          // find campaign
          const callCampaignName = callTrackingActivity?.callActivityDetails
            .find((x) => x.callTrackingSystemFieldId === CampaignFieldId)
            ?.fieldValue?.toUpperCase()

          if (callCampaignName) {
            const foundLeadCampaign = campaigns.find(
              (x) => x.name.substring(0, 10) === callCampaignName,
            )

            if (foundLeadCampaign) {
              setFieldValue(entityCampaignId, foundLeadCampaign?.id)
              setFieldValue('campaign', foundLeadCampaign?.name)
            }
          }

          setFieldValue(
            'CallTrackingSystemFieldValues',
            callTrackingActivity?.callActivityDetails.filter(
              (x) => x.fieldValue !== null,
            ),
          )
          return
        } else {
          setFieldValue(entityLeadSourceId, leadSourceNoneId)
          setFieldValue('leadSource', leadSourceNone)
        }
      } else {
        setFieldValue(entityLeadSourceId, leadSourceNoneId)
        setFieldValue('leadSource', leadSourceNone)
      }

      setFieldValue(
        'CallTrackingSystemFieldValues',
        callTrackingActivity?.callActivityDetails.filter(
          (x) => x.fieldValue !== null,
        ),
      )
    } else {
      setCampaignDisabled(false)
      if (
        !campaignId &&
        requiredCampaignId &&
        showCampaign &&
        campaigns?.length == 1
      ) {
        setFieldValue(entityCampaignId, campaigns[0].id)
        setFieldValue('campaign', campaigns[0].name)
      }
      if (
        !leadSourceId &&
        requiredLeadSourceId &&
        showLeadSource &&
        leadSources?.length == 1
      ) {
        setFieldValue(entityLeadSourceId, leadSources[0].id)
        setFieldValue('leadSource', leadSources[0].name)
      }
    }
  }, [
    callTrackingActivity,
    setValues,
    setFieldValue,
    leadSources,
    campaigns,
    setCampaignDisabled,
  ])
}
